import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=08f0144b&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=08f0144b&prod&lang=scss&scoped=true&"
import style1 from "./ClientList.vue?vue&type=style&index=1&id=08f0144b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0144b",
  null
  
)

export default component.exports